import React, { useState, useEffect } from 'react'
import { getAllNotifications, createNotification, deleteNotification, updateNotificationStatus } from '../services/notifications/NotificationService';
import { getNotificationByName } from '../services/notifications/NotificationService';
import FancyPaper from '../components/FancyPaper'
import { Button, Dialog, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import ResourceAccess from '../components/security/ResourceAccess'
import { PenIcon, PlusIcon, TrashIcon } from '../components/svgicons/SvgIcons'
import { EyeIcon } from '../components/svgicons/EyeIcon';
import EmailsModal from '../components/utils/EmailsModal';
import FancySearch from "../components/utils/FancySearch";
import FancyTooltip from '../components/utils/FancyTooltip'
import theme from '../theme/theme'
import FancyTablePagination from '../components/utils/FancyTablePagination'
import AddOrUpdateProviderModal from '../components/utils/AddOrUpdateProviderModal'
import DeleteModal from '../components/utils/DeleteModal'
import FancyDialogActions from '../components/utils/FancyDialogActions'
import { useApp } from '../hooks/useApp'
import { useForm } from 'react-hook-form'
import AddOrUpdateNotificationModal from '../components/utils/AddOrUpdateNotificationModal'

const SettingNotifications = () => {
    // Hooks para el modal de emails (deben estar dentro del componente)
    const [openEmailsModal, setOpenEmailsModal] = useState(false);
    const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
    const [selectedName, setSelectedName] = useState<string>('');
    // Ref para el botón que abre el modal de emails
    const emailsButtonRef = React.useRef<HTMLButtonElement | null>(null);
    const handleOpenEmailsModal = (emails: string[], name: string) => {
        setSelectedEmails(emails);
        setSelectedName(name);
        setOpenEmailsModal(true);
    };
    const handleCloseEmailsModal = () => {
        setOpenEmailsModal(false);
        setSelectedEmails([]);
        setSelectedName('');
        // Devuelve el foco al botón que abrió el modal
        if (emailsButtonRef.current) {
            emailsButtonRef.current.focus();
        }
    };
    const [preFilter, setPreFilter] = useState<any>();
    const [page, setPage] = useState(0);
    const [notificationsData, setNotificationsData] = useState<any>([]);
    const { authInfo, setLoading, setErrorMsg, modalData, setModalData, setSuccessMsg, errorMsg, } = useApp();
    const { handleSubmit } = useForm();

    const handleFetchData = async (filter: string, currentPage: number) => {

    }
    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await getAllNotifications();
                setNotificationsData(Array.isArray(response) ? response : response.data || []);
            } catch (error) {
                console.error('Error al obtener notificaciones:', error);
            }
        };
        fetchNotifications();
    }, []);

    const handleChangePage = async (event: unknown, newPage: number) => {
        setPage(newPage - 1);
        let customPage = newPage - 1;
        if (customPage !== page) {
            await handleFetchData(preFilter, customPage);
        }
    };
    const handleAdd = async (data: any) => {
        try {
            // Verificar si ya existe una notificación con ese nombre
            const exists = await getNotificationByName(data.name);
            if (exists && exists.data) {
                setErrorMsg && setErrorMsg("Ya existe una notificación con ese nombre.");
                return;
            }
            // Construir el objeto para el endpoint
            const payload = {
                event: data.name,
                emails: data.emails,
                active: data.active,
                createUser: authInfo?.userName || "admin",
                templateCode: "WELCOME_EMAIL"
            };
            await createNotification(payload);
            // Refrescar la lista de notificaciones
            const response = await getAllNotifications();
            setNotificationsData(Array.isArray(response) ? response : response.data || []);
            setSuccessMsg && setSuccessMsg("Notificación creada correctamente");
        } catch (error) {
            setErrorMsg && setErrorMsg("Error al crear notificación");
        }
        handleCancelModal();
    };
    const handleUpdate = async (data: any) => {
        try {
            // Construir el objeto para el endpoint

            const payload = {
                emails: data.emails,
                active: data.active,
                templateCode: data.name,
                modificationUser: authInfo?.userName || "admin",
            };
            await updateNotificationStatus(data.id, payload);
            // Refrescar la lista de notificaciones
            const response = await getAllNotifications();
            setNotificationsData(Array.isArray(response) ? response : response.data || []);
            setSuccessMsg && setSuccessMsg("Notificación actualizada correctamente");
        } catch (error) {
            setErrorMsg && setErrorMsg("Error al actualizar notificación");
        }
        handleCancelModal();
    };
    const handleDelete = async (id: number) => {
        try {
            // Buscar el eventName por id
            const notification = notificationsData.find((n: any) => n.id === id);
            if (!notification) throw new Error("Notificación no encontrada");
            await deleteNotification(notification.event);
            // Refrescar la lista de notificaciones
            const response = await getAllNotifications();
            setNotificationsData(Array.isArray(response) ? response : response.data || []);
            setSuccessMsg && setSuccessMsg("Notificación eliminada correctamente");
        } catch (error) {
            setErrorMsg && setErrorMsg("Error al eliminar notificación");
        }
        handleCancelModal();
    }
    const handleOpenModal = async (event: any) => {
        event.preventDefault();
        const modalAction = event.currentTarget.getAttribute("data-name");
        let object = null;
        const id = event.currentTarget.getAttribute("data-id");

        if (modalAction === "update") {
            // await handleFetchByID(id);
            object = notificationsData.find((p: any) => p.id === parseInt(id));
        }

        if (modalAction === "delete") {
            object = notificationsData.find((p: any) => p.id === parseInt(id));
            //object = FakeData.content.find((p: any) => p.id === parseInt(id));
        }
        //open modal
        setModalData &&
            setModalData({
                ...modalData,
                modalOpen: true,
                modalType: modalAction,
                modalObject: object,
            });
    }

    const handleCancelModal = () => {
        setModalData &&
            setModalData({
                ...modalData,
                modalOpen: false,
                modalType: "",
                modalObject: null,
            });
    };
    const onSubmit = async (data: any) => {
        switch (modalData?.modalType) {
            case "create":
                await handleAdd(data);
                break;
            case "update":
                await handleUpdate(data);
                break;
            case "delete":
                await handleDelete(modalData?.modalObject?.id);
                break;
            default:
                break;
        }
    };



    return (
        <>
            <FancyPaper pagetitle="Notificaciones" prevpage="Inventario" linkprevpage="">
                <Grid container spacing={8} sx={{ pb: 8 }}>
                    <Grid item md={7} sm={5} xs={12}>
                        <ResourceAccess isCode={true} pathOrCode={"NOTIFICATION:WRITE"}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleOpenModal}
                                data-name="create"
                            >
                                {"Agregar Notificación"}
                                <PlusIcon sx={{ ml: 1 }} />
                            </Button>
                        </ResourceAccess>
                    </Grid>
                </Grid>
                <Divider />
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Emails</TableCell>
                                <TableCell>Estado</TableCell>
                                <ResourceAccess isCode={true} pathOrCode={"PROVIDER:WRITE"}>
                                    <TableCell align="center">{"Acciones"}</TableCell>
                                </ResourceAccess>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {notificationsData &&
                                notificationsData
                                    .slice(page * 6, page * 6 + 6)
                                    .map((r: any) => (
                                        <TableRow key={r.id}>
                                            <TableCell scope="row">{r.id}</TableCell>
                                            <TableCell align="center">{r.event}</TableCell>
                                            <TableCell align="center">
                                                <IconButton
                                                    onClick={() => handleOpenEmailsModal(r.emails, r.event)}
                                                    ref={emailsButtonRef}
                                                >
                                                    <EyeIcon style={{ color: '#111' }} />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="center">
                                                {r.active ? "Activo" : "Desactivado"}
                                            </TableCell>
                                            <EmailsModal
                                                open={openEmailsModal}
                                                onClose={handleCloseEmailsModal}
                                                emails={selectedEmails}
                                                name={selectedName}
                                            />
                                            <TableCell align="center">
                                                <ResourceAccess
                                                    isCode={true}
                                                    pathOrCode={"NOTIFICATION:WRITE"}
                                                >
                                                    <FancyTooltip title={"Editar"} placement="top">
                                                        <IconButton
                                                            aria-label="edit"
                                                            component="label"
                                                            color="primary"
                                                            onClick={handleOpenModal}
                                                            data-name="update"
                                                            data-id={r.id}
                                                        >
                                                            <PenIcon />
                                                        </IconButton>
                                                    </FancyTooltip>
                                                    <FancyTooltip title={"Eliminar"} placement="top">
                                                        <IconButton
                                                            aria-label="trash"
                                                            component="label"
                                                            color="error"
                                                            sx={{
                                                                "&:hover": {
                                                                    color: theme.palette.error.dark,
                                                                },
                                                            }}
                                                            data-id={r.id}
                                                            onClick={handleOpenModal}
                                                            data-name="delete"
                                                        >
                                                            <TrashIcon />
                                                        </IconButton>
                                                    </FancyTooltip>
                                                </ResourceAccess>
                                            </TableCell>
                                        </TableRow>
                                    ))
                            }
                            {!notificationsData ||
                                (notificationsData.length <= 0 && (
                                    <TableRow>
                                        <TableCell colSpan={12} align="center">
                                            {"No hay registros"}
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <FancyTablePagination
                    count={
                        notificationsData.length > 0
                            ? notificationsData.length
                            : 0
                    }
                    rowsPerPage={6}
                    page={page}
                    onPageChange={handleChangePage}
                    totalElements={notificationsData.length}
                    totalPages={Math.ceil((notificationsData.length || 1) / 7)}
                />
            </FancyPaper>
            {(modalData?.modalType === "create" ||
                modalData?.modalType === "update") && (
                    <Dialog
                        open={modalData.modalOpen}
                        onClose={handleCancelModal}
                        fullWidth
                    >
                        <AddOrUpdateNotificationModal
                            data={modalData?.modalObject}
                            onSubmit={onSubmit}
                            cancelModal={handleCancelModal}
                            modalType={modalData?.modalType}
                        />
                    </Dialog>
                )}
            {modalData?.modalType === "delete" && (
                <Dialog
                    open={modalData.modalOpen}
                    onClose={handleCancelModal}
                    fullWidth
                >
                    <DeleteModal
                        //@ts-ignore
                        textChildren={modalData?.modalObject?.code}
                        actionButton={
                            <>
                                <FancyDialogActions
                                    handleAccept={handleSubmit(onSubmit)}
                                    cancelModal={handleCancelModal}
                                    textAcceptButton={"Eliminar"}
                                />
                            </>
                        }
                    />
                </Dialog>
            )}
        </>
    )
}

export default SettingNotifications